export const BOOK_AND_PAID_LATER_LOADING = 'BOOK_AND_PAID_LATER_LOADING';
export const BOOK_AND_PAID_LATER_SUCCESS = 'BOOK_AND_PAID_LATER_SUCCESS';
export const BOOK_AND_PAID_LATER_ERROR = 'BOOK_AND_PAID_LATER_ERROR';
export const BOOK_AND_PAID_LATER_RESET = 'BOOK_AND_PAID_LATER_RESET';
